import React, {useRef, useState} from "react";

import { useTranslation } from "react-i18next";

import {Form, Card, Row, Col} from "react-bootstrap"
import HeaderCounters from "../HeaderCounters/HeaderCounters"
import { useGetClient, useGetClientProfileCounters } from "../../hooks/useOfClient"
import ProfileOptionButtons from '../Controls/Buttons/ProfileOptionButtons';
import { Shimmer, ShimmerElementsGroup, ShimmerElementType } from '@fluentui/react/lib/Shimmer';

import imgProfileNN from "../../images/nn.png"

const ClientHeader = (props) => {

    const { t } = useTranslation();
    
    const clientId = props.clientId;
    const showEditProfile = props.showEditProfile;
    //const showManageSecurity = props.showManageSecurity;
    
    const imgProfileWidthXs = useRef();
    const imgProfileWidthXl = useRef();

    const [clientInfo, setClientInfo] = useState(null);
    useGetClient((clientId !== null) ? clientId: null, setClientInfo);
    
    const [clientHeaderCounters, setClientHeaderCounters] = useState(null);
    useGetClientProfileCounters((clientInfo !== null) ? clientInfo.clientId: null, setClientHeaderCounters);

    /*const getBase64Image = async (url) => {
        const img = new Image();
        img.setAttribute('crossOrigin', 'anonymous');
        img.src = url;
        img.onload = async () => {
          try {
                const canvas = document.createElement("canvas");
                canvas.width = img.width;
                canvas.height = img.height;
                const ctx = canvas.getContext("2d");
                ctx.drawImage(img, 0, 0);
                const dataURL = canvas.toDataURL("image/png");
      
                imgProfileWidthXs.current.src = dataURL;
                imgProfileWidthXl.current.src = dataURL;
            }
            catch (error) {
            
            }
        };
    }*/
    
    const clientOptionMenuItems = clientInfo !== null ? [
        //{
        //    text: t('data-lang-sidenavbar-managepermissions'),
        //    iconName: 'Encryption',
        //    key: 'managepermissions',
        //    stateValue: {clientId: clientInfo.clientId},
        //    show: showManageSecurity
        //},
        {
            text: t('data-lang-btn-editprofile'),
            iconName: 'EditContact',
            key: 'editclient',
            stateValue: {clientId: clientInfo.clientId},
            show: showEditProfile
        }
    ] : [];

    /*const getClientPicture = async (obj) => {
        let path = Buffer.from(decodeURIComponent(obj), "base64").toString();
        await getBase64Image(path);
    }*/

    if (clientInfo !== null && imgProfileWidthXs.current && imgProfileWidthXl.current) {
        //getClientPicture(user.pictureUrl);
        imgProfileWidthXs.current.src = (clientInfo.pictureUrl !== null && clientInfo.pictureUrl !== undefined) ? clientInfo.pictureUrl : imgProfileNN;
        imgProfileWidthXl.current.src = (clientInfo.pictureUrl !== null && clientInfo.pictureUrl !== undefined) ? clientInfo.pictureUrl : imgProfileNN;           
    }

    return (
        <>
                <Card className="rounded-3">
                    <Card.Title>
                    <h4 className="pb-2" style={{borderBottom: "2px solid #b1b1b1"}}>{t('data-lang-pagename-profile-client')}
                        <ProfileOptionButtons items={ clientOptionMenuItems } />
                    </h4>
                    </Card.Title>
                    { clientInfo && 
                        <>
                            <div className="mx-auto d-block d-sm-block d-md-none d-lg-none">  
                                <img className="rounded-circle border border-2 border-warning" alt="img" width={125} ref={imgProfileWidthXs} ></img>
                            </div>
                            <div className="card-horizontal">
                                <div className="pt-4 d-none d-sm-none d-md-block d-lg-block">  
                                    <img className="rounded-circle border border-2 border-warning" alt="img" width={125} ref={imgProfileWidthXl} ></img>
                                </div>
                                <Card.Body className="col-xs-12">
                                    <Row>
                                        <Col xs={12} sm={12} md={6} lg={4} xl={4} className="text-center text-sm-center text-md-start">
                                            <Form.Label><h4>{clientInfo.name}</h4></Form.Label>
                                            <Form.Label><b>{t('data-lang-lbl-domain')}: </b>{clientInfo.domain}</Form.Label>
                                            <Form.Label><b>{t('data-lang-lbl-type')}: </b>{clientInfo.type}</Form.Label>
                                            <Form.Label><b>{t('data-lang-lbl-locale')}: </b>{clientInfo.locale}</Form.Label>
                                        </Col>
                                        <Col xs={12} sm={12} md={6} lg={4} xl={4} className="text-center text-sm-center text-md-end ms-auto col-auto text-end">
                                            <HeaderCounters showDetail={false} detail={""} textList={[t('data-lang-lbl-users'), t('data-lang-lbl-contracts')]} counters={clientHeaderCounters} />
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </div>
                        </>
                    }
                    { !clientInfo &&
                        <Shimmer
                            customElementsGroup={
                                <div style={{ display: 'flex' }}>
                                    <ShimmerElementsGroup
                                        shimmerElements={[
                                            { type: ShimmerElementType.circle, height: 125 },
                                            { type: ShimmerElementType.gap, width: 16, height: 125 },
                                        ]}
                                    />
                                    <ShimmerElementsGroup
                                        flexWrap
                                        width="100%"
                                        shimmerElements={[
                                            { type: ShimmerElementType.line, width: '100%', height: 10, verticalAlign: 'bottom' },
                                            { type: ShimmerElementType.line, width: '100%', height: 10 },
                                            { type: ShimmerElementType.line, width: '100%', height: 10 },
                                            { type: ShimmerElementType.line, width: '100%', height: 10 },
                                            { type: ShimmerElementType.gap, width: '100%', height: 25 },
                                        ]}
                                    />
                                </div>
                            }
                            styles={{
                                root: {
                                    width:"100%",
                                    height:"150px",
                                    backgroundColor: "white"}
                                }
                            }
                            className="pt-4"
                            isDataLoaded={clientInfo !== null}>
                        </Shimmer>
                    }
                </Card>

        </>
    );
};

export default ClientHeader;


